// extracted by mini-css-extract-plugin
module.exports = {"CommentListPlaceholder":"if_a bhe_je","CommentListPlaceholder--Legacy":"if_b bhe_qh bhe_vk"};